import { NavLink } from "react-router-dom";
import classes from "./Header.module.css";

function Header({ user }) {
  return (
    <header className={classes.header}>
      <div className={classes.greeting}>
        {user && (
          <span>Hey, {user.username ? user.username : "User"} #</span>
        )}
        {!user && <span>R-Message</span>}
      </div>
      <div className={classes.links}>
        <NavLink to={"/"}>Home</NavLink>
        {user && <NavLink to={"/chats"}>Chats</NavLink>}
        {!user && <NavLink to={"/login"}>Login</NavLink>}
        {user && <NavLink to={"/logout"}>Logout</NavLink>}
      </div>
    </header>
  );
}

export default Header;
